import styled from "styled-components";
export const SobreContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: linear-gradient(90deg, #ffe1bc 0%, #fff7ee 100%);
  justify-content: space-between;
  gap: 2%;
  width: 100%;
  padding: 3% 10%;

  @media (max-width: 1200px) {
    gap: 5%;
    padding: 3% 7%;
  }

  @media (max-width: 1000px) {
    padding: 3% 3%;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    padding: 3% 10%;
    gap: 20px;
  }

  @media (max-width: 600px) {
    padding: 3% 5%;
  }
`;

export const DivGeral = styled.div`
  width: 50%;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const DivAlertInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  img {
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
`;

export const DivAlertInfoContact = styled.div`
  display: flex;
  flex-direction: column;
  img {
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const DivAlertInfoP = styled.p`
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 108%;
  vertical-align: middle;
  color: #000000;

  @media (max-width: 500px) {
    font-size: 0.8rem;
  }
`;

export const DivAlertInfo2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h2 {
    font-size: 1.2rem;
    font-weight: 700;
    color: #881c15;
    font-family: "Montserrat", sans-serif;
    line-height: 23px;
    letter-spacing: 0;
    vertical-align: middle;
    color: #000000;
    margin: 0;
    margin-bottom: 20px;
    padding: 0;
  }

  p {
    font-size: 1rem;
    color: #000000;
    letter-spacing: 0;
    line-height: 108%;
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    padding: 0;
    margin: 0;
  }

  @media (max-width: 900px) {
    display: none !important;
  }
`;

export const DivAlertInfo3 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  img {
    max-width: 150px;
    margin-bottom: 10px;
  }

  h2 {
    font-size: 1rem;
    font-weight: 700;
    color: #560000;
    font-family: "Montserrat", sans-serif;
    line-height: 23px;
    letter-spacing: 0;
    vertical-align: middle;
    margin: 0;
    padding: 0;
  }

  p {
    font-size: 1rem;
    color: #560000;
    letter-spacing: 0;
    line-height: 108%;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10%;
  background: #222222;

  color: #fff;
  gap: 20px;

  p {
    font-size: 1rem;
    color: #fff;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    line-height: 108%;
    letter-spacing: 0;
    margin: 0;
    text-align: center;

    @media (max-width: 900px) {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    padding: 20px 5%;
  }
`;
